// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1OPlp","empty":"ModalGraph_empty__2dz2J"};